(function () {
    angular.module('harriApp').controller('gpCareerPortalFilters', [
        '$scope', 'modalData',
        function ($scope, modalData) {

            var self = this;
            self.modalData = modalData;
            self.categories = modalData.categories;
            self.brand = modalData.brand;
            self.isTenantJobEnabled = (self.brand.public_services && self.brand.public_services.indexOf('TENANT_JOBS') > -1);
            var allPositions = modalData.positions;
            self.filter = modalData.filters || {};
            self.settings = modalData.settings;

            self.apply = function () {
                modalData.onApply(self.filter);
                self.close();
            };

            var initSelectedCategoriesAndPositions = function () {
                var catIds = _.pluck(self.filter.selectedCategories || [], 'id');
                self.filter.selectedCategories = _.filter(self.categories, function (category) {
                    return catIds.indexOf(category.id) > -1;
                });
                var selectedCategories = self.filter.selectedCategories;
                var selectedCategoryPositions = [];
                var positions = [];
                if (selectedCategories && selectedCategories.length) {
                    for (var i in selectedCategories) {
                        positions = selectedCategories[i]['position_objects'];
                        selectedCategoryPositions = selectedCategoryPositions.concat(positions);
                    }
                    self.positions = selectedCategoryPositions;

                } else {
                    self.positions = allPositions;
                }
                var selectedPositionCodes = _.pluck(self.filter.selectedPositions, 'code');
                self.filter.selectedPositions = _.filter(self.positions, function (position) {
                    return selectedPositionCodes.indexOf(position.code) > -1;
                });
            };

            var initSelectedBrands = function (items) {
                items.forEach(function (brand) {
                    brand.external_business_name = brand.external_business_name || brand.name;
                });

                return items;
            };

            var init = function(){
                initSelectedCategoriesAndPositions();
            };

            self.onChangeCategories = function () {
                initSelectedCategoriesAndPositions();
            };

            self.reset = function () {
                self.filter.selectedCategories = [];
                self.filter.selectedPositions = [];
                self.filter.selectedBrands = [];
                self.filter.schedule.fullTime = false;
                self.filter.schedule.partTime = false;
                self.apply();
            };

            self.getBrandsBySearchQuery = function ($event) {
                var defer = $q.defer();
                $event.on('start');

                var search_term = $event.value;
                var allowedBrandType = self.settings.brand_filter_allowed_brand_type;
                var brandId = self.brand.id;
                var brandFilterObject = self.filter.brandFilterObject;
                var brand_type = brandFilterObject ? '' : allowedBrandType;
                var filteredSelectedBrands = self.filter.selectedBrands || [];

                BrandAPI.getFlattedBrandsTree(brandId, brand_type, 0, 400, 'CAREER_PORTAL', search_term)
                    .then(function (brandsList) {
                        var items = [];

                        if (!brandFilterObject) {
                            items = brandsList.brands;
                        } else if (allowedBrandType){
                            items = _.filter(brandsList.brands, function (brand) {
                                return brand.type === allowedBrandType;
                            });
                        }
                        initSelectedBrands(items);

                        if (!brandFilterObject) {
                            var filteredSelectedBrandIds = _.pluck(filteredSelectedBrands, 'id');

                            self.filter.selectedBrands = items.filter(function (brand) {
                                return filteredSelectedBrandIds.indexOf(brand.id) > -1;
                            });
                        }

                        defer.resolve(items);
                    }).catch(function (error) {
                    console.error(error);
                }).finally(function () {
                    $event.on('end');
                });
                return defer.promise;
            };

            self.onSelectedBrandsChanged = function (selected) {
                self.filter.selectedBrands = angular.copy(selected);
            }

            self.close = function () {
                $scope.$hide();
            };

            init();

        }]);
})();
